import { createSelector } from 'reselect';

import { StoreType } from './index';
import { getMindItems } from './mindItems.selectors';
import { getProducts } from './products.selectors';
import { getContent } from './selectorHelpers';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import { ContentItem } from '../types/AppContent';
import { RecentlyViewedContentArray } from './recentlyViewed.reducers';

const getRecentlyViewedContents = (
  state: StoreType
): RecentlyViewedContentArray => state.recentlyViewed.contents;

export const selectRecentlyViewedStatus = (
  state: StoreType
): AsyncActionStatus => state.recentlyViewed.status;

export const selectRecentlyViewedContents = createSelector(
  [getRecentlyViewedContents, getMindItems, getProducts],
  (recentlyViewed, mindItems, products) =>
    recentlyViewed
      .map((i) => getContent(i.type, i.id, mindItems, products))
      .filter((v) => !!v) as ContentItem[]
);
